onComplete(function() {

	/* Toon Faq categorie title niet als er maar 1 is */
	const faqTitles = document.querySelectorAll('.faq-page [data-partial="faq"] .title')

	if (faqTitles.length === 1) {
		faqTitles[0].style.display = "none";
	}
});